export default class UserUpsertModel {
  public calendarId = "";
  public calendarUserId = "";
  public order = "";

  constructor(data?: unknown) {
    if (!data) {
      return;
    }

    Object.assign(this, data);
  }
}
